export const WIDGET_DEFAULT_HEIGHT = '90vh';
export const WIDGET_DEFAULT_WIDTH = 'CLASSIC';
export const iframeWidth = 'LARGE';
